<template>
  <div class="ts-overflow-auto" style="max-height: 50vh">
    <table class="ts-w-full">
      <thead>
        <tr>
          <th class="action-column ts-text-center" v-if="!isNotAllowUpdate">
            <a href="#" class="ts-text-white" @click.prevent="addNewRow">
              <i class="fa fa-plus"></i>
            </a>
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.barcode') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.productName') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.expireDate') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.uom') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.costTHB') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.cost') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center"
          >
            {{ $t('stockIn.qty') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.discount') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
          >
            {{ $t('stockIn.discountType') }}
          </th>
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right"
          >
            {{ $t('stockIn.vatRate') }}
          </th>
          <!-- <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right">{{ $t('stockIn.grade') }}</th> -->
          <th
            class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-right"
          >
            {{ $t('stockIn.amount') }}
          </th>
          <template v-if="isImportProduct">
            <th class="tax-column">CPP Tax Base</th>
            <th class="tax-column">CPP Rate</th>
            <th class="tax-column">CPP Amount</th>
            <th class="tax-column">Form D (CPP 0)</th>
            <th class="tax-column">SPP Tax Base</th>
            <th class="tax-column">SPP Rate</th>
            <th class="tax-column">SPP Amount</th>
            <th class="tax-column">VPP Tax Base</th>
            <th class="tax-column">VPP Rate</th>
            <th class="tax-column">VPP Amount</th>
            <th class="tax-column total-tax-column">Total Tax</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, index) in model.product_detail" :key="index">
          <td class="action-column ts-text-center" valign="middle" v-if="!isNotAllowUpdate">
            <a href="#" class="ts-text-red-600 ts-my-auto" @click.prevent="removeRow(detail)">
              <i class="fa fa-trash"></i>
            </a>
          </td>
          <td valign="top" class="ts-w-32">
            <input
              type="text"
              class="form-control"
              style="min-width: 90px"
              readonly
              :value="
                findProduct(detail.product_id)
                  ? findProduct(detail.product_id).barcode
                  : ''
              "
            />
            <!-- <a-select
              ref="barcode"
							v-model="detail.product_id" 
							class="ts-w-full"
              :class="{ 'is-invalid': errors.has('product_detail.' + index + '.product_id')}"  
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              @change="onProductChange(detail)"
						>
              <a-select-option 
								v-for="(pro, index) in getProduct({ 
									chosenProduct: model.product_detail,
									productCurrentRow: detail.product_id
								})" 
								:key="index"
								:value="pro.product_id"
							>{{ pro.barcode }}</a-select-option>
            </a-select> -->
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.product_id')"
            >
              {{ errors.first('product_detail.' + index + '.product_id') }}
            </div>
          </td>
          <td valign="top" style="width: 300px">
            <div class="ts-flex">
              <!-- <a-select 
							v-model="detail.product_id"
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              class="ts-w-full"
              :class="{ 'is-invalid': errors.has('product_detail.' + index + '.product_id')}"  
              @change="onProductChange(detail)"
						>
              <a-select-option
                v-for="(pro, index) in getProduct({ 
									chosenProduct: model.product_detail,
									productCurrentRow: detail.product_id
								})"
                :key="index"
								:value="pro.product_id"
              >{{ pro.product_name_en }}</a-select-option>
            </a-select> -->
              <input
                type="text"
                class="form-control"
                style="min-width: 300px"
                readonly
                :value="
                  findProduct(detail.product_id)
                    ? findProduct(detail.product_id).product_name_en
                    : ''
                "
              />
              <a-popover :title="$t('stockIn.serial')" placement="bottomLeft">
                <template slot="content">
                  <div class="scroll">
                    <!-- <p><b>Total Serial: {{ detail.qty > 1 ? detail.qty : 0 }}</b></p>
                    <div style="max-width: 300px">
                      <p v-for="(s, i) in detail.imei_list" :key="i" style="width: 150px;">
                        {{ s[0] }}
                      </p>
                    </div> -->
                    <ul>
                      <b>Total Serial: {{ detail.qty > 1 ? detail.qty : 0 }}</b>
                      <div class="ts-grid ts-grid-cols-2">
                        <li
                          v-for="(s, i) in detail.imei_list"
                          :key="i"
                          class="ts-px-4 ts-whitespace-no-wrap"
                        >
                          {{ s[0] }}
                        </li>
                      </div>
                    </ul>
                  </div>
                </template>
                <label
                  v-show="
                    findProduct(detail.product_id)
                      ? findProduct(detail.product_id).require_imei === true
                      : false
                  "
                  :for="'file_' + index"
                  class="ts-border ts-px-2 ts-py-2 ts-rounded-md ts-cursor-pointer ts-h-8"
                  :class="
                    findProduct(detail.product_id) ? 'ts-border-blue-600' : ''
                  "
                  ><i class="fas fa-file-excel"></i
                ></label>
                <input
                  type="file"
                  :ref="'file_' + index"
                  :id="'file_' + index"
                  class="ts-hidden"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="e => onFileChange(e, detail)"
                  :class="{
                    'is-invalid': errors.has(
                      'product_detail.' + index + '.imei_list'
                    )
                  }"
                />
              </a-popover>
            </div>
            <div
              class="ts-text-red-600 ts-text-xs"
              v-if="errors.first('product_detail.' + index + '.imei_list')"
            >
              {{ errors.first('product_detail.' + index + '.imei_list') }}
            </div>
          </td>
          <td valign="top" class="ts-w-48">
            <a-date-picker
              v-model="detail.expiry_date"
              :disabled="!detail.is_expire"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="min-width: 120px"
              class="ts-w-full"
              :class="{
                'is-invalid': errors.has(
                  'product_detail.' + index + '.expiry_date'
                )
              }"
            ></a-date-picker>
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.expiry_date')"
            >
              {{ errors.first('product_detail.' + index + '.expiry_date') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <a-select
              v-model="detail.uom_id"
              class="ts-w-full"
              style="min-width: 90px"
              :class="{
                'is-invalid': errors.has('product_detail.' + index + '.uom_id')
              }"
              :disabled="isNotAllowUpdate"
              @change="onUomChange(detail)"
            >
              <a-select-option
                v-for="(u, index) in getUom(detail.product_id)"
                :key="index"
                :value="u.uom_id"
                >{{ u.uom_name_en }}
              </a-select-option>
            </a-select>
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.uom_id')"
            >
              {{ errors.first('product_detail.' + index + '.uom_id') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <ts-currency-input
              v-model.number="detail.cost_in_bath"
              class="form-control ts-text-right"
              style="min-width: 100px"
              currency="฿"
              :precision="default_precision"
              :disabled="isNotAllowUpdate"
              @input="onThbInput(detail)"
            />
            <div
              class="validate"
              v-if="errors.has('product_detail.' + index + '.cost')"
            >
              {{ errors.first('product_detail.' + index + '.cost') }}
            </div>
          </td>
          <td valign="top" class="ts-w-32">
            <ts-currency-input
              v-model.number="detail.cost"
              @keypress.enter="onCostEnter(index)"
              class="form-control ts-text-right"
              style="min-width: 100px"
              :currency="default_currency_sign"
              :precision="default_precision"
              :disabled="isNotAllowUpdate"
              @input="onUsdInput(detail)"
            />
            <div
              class="validate"
              v-if="errors.has('product_detail.' + index + '.cost')"
            >
              {{ errors.first('product_detail.' + index + '.cost') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <input
              v-model.number="detail.qty"
              type="number"
              ref="qty"
              @keypress.enter="onQtyEnter(index)"
              @input="calculate()"
              class="form-control ts-text-center"
              :class="{
                'is-invalid': errors.has('product_detail.' + index + '.qty')
              }"
              :readonly="isNotAllowUpdate"
              style="min-width: 80px"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.qty')"
            >
              {{ errors.first('product_detail.' + index + '.qty') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <input
              ref="discountRate"
              v-model.number="detail.discount_rate"
              @keypress.enter="onDiscountRateEnter(index)"
              type="number"
              class="form-control"
              :class="{
                'is-invalid': errors.has(
                  'product_detail.' + index + '.discount_rate'
                )
              }"
              :readonly="isNotAllowUpdate"
              @change="calculate()"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.discount_rate')"
            >
              {{ errors.first('product_detail.' + index + '.discount_rate') }}
            </div>
          </td>
          <td valign="top" class="ts-w-24">
            <select
              ref="discountType"
              @keypress.enter="discountTypeEnter(index)"
              v-model="detail.discount_type"
              class="form-control"
              :disabled="isNotAllowUpdate"
              @change="calculate()"
            >
              <option value="%">%</option>
              <option :value="default_currency_sign">
                {{ default_currency_sign }}
              </option>
            </select>
          </td>
          <td valign="top" class="ts-w-24">
            <!-- @keypress.enter="pressEnterAddNewRow(index)"   -->
            <input
              v-model.number="detail.vat_rate"
              ref="vatRate"
              type="number"
              class="form-control ts-text-right"
              :class="{
                'is-invalid': errors.has(
                  'product_detail.' + index + '.vat_rate'
                )
              }"
              style="min-width: 80px"
              @input="calculate()"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('product_detail.' + index + '.vat_rate')"
            >
              {{ errors.first('product_detail.' + index + '.vat_rate') }}
            </div>
          </td>
          <!-- <td valign="top" class="ts-w-24">
              <select class="form-control"
                v-model="detail.product_grade"
              >
                <option value="">--</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
              </select>
          </td> -->
          <td valign="top" class="ts-w-32">
            <ts-currency-input
              v-model="detail.total_after_discount"
              class="form-control ts-text-right"
              style="min-width: 120px"
              disabled
              :currency="default_currency_sign"
              :precision="default_precision"
            />
          </td>
          <template v-if="isImportProduct">
            <td class="tax-cell">
              <ts-currency-input v-model="detail.cpp_price_for_tax" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="tax-rate-cell">
              <input class="form-control ts-text-right" type="text" :value="formatTaxRate(detail.cpp_rate)" readonly />
            </td>
            <td class="tax-cell">
              <ts-currency-input v-model="detail.cpp_tax_amount" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="form-d-cell ts-text-center">
              <input v-model="detail.form_d_cpp_0" type="checkbox" :disabled="isNotAllowUpdate || detail.cpp_rate === null" @change="calculate" />
            </td>
            <td class="tax-cell">
              <ts-currency-input v-model="detail.spp_price_for_tax" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="tax-rate-cell">
              <input class="form-control ts-text-right" type="text" :value="formatTaxRate(detail.spp_rate)" readonly />
            </td>
            <td class="tax-cell">
              <ts-currency-input v-model="detail.spp_tax_amount" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="tax-cell">
              <ts-currency-input v-model="detail.vpp_price_for_tax" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="tax-rate-cell">
              <input class="form-control ts-text-right" type="text" :value="formatTaxRate(detail.vpp_rate)" readonly />
            </td>
            <td class="tax-cell">
              <ts-currency-input v-model="detail.vpp_tax_amount" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
            <td class="tax-cell total-tax-cell">
              <ts-currency-input v-model="detail.total_tax_payment" class="form-control ts-text-right" disabled currency="៛" :precision="tax_precision" />
            </td>
          </template>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td v-if="!isNotAllowUpdate"></td>
          <td class="footer-total ts-text-red-700">
            {{ $t('purchaseOrder.numberRow') + ': ' }}{{ model.product_detail.length }}
          </td>
          <td class="footer-total ts-text-red-700 ts-text-right" colspan="5">
            {{ $t('purchaseOrder.total') + ': ' }}
          </td>
          <td class="footer-total ts-text-red-700 ts-text-center">
            {{ $formatNumber(sumTotalQty) }}
          </td>
          <td colspan="3"></td>
          <td class="footer-total ts-text-red-700 ts-text-right">
            {{ $defaultCurrencyWithCode(grandTotal, default_precision) }}
          </td>
          <td v-if="isImportProduct" class="footer-total ts-text-red-700 ts-text-right" colspan="10">
            Total Tax:
          </td>
          <td v-if="isImportProduct" class="footer-total ts-text-red-700 ts-text-right">
            {{ '៛ ' + $formatNumber(sumTotalTax, tax_precision) }}
          </td>
        </tr>
      </tfoot>
    </table>

    <!-- modal show pop-up to be able add product -->
    <a-modal
      v-if="show_modal_add_product"
      v-model="show_modal_add_product"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      width="900px"
      :title="$t('stockIn.product')"
    >
      <SearchToAdd v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import SearchToAdd from './search-to-add.vue'

export default {
  name: 'productDetails',
  props: ['value', 'validate'],
  components: {
    SearchToAdd
  },
  data() {
    return {
      errors: new Errors(),
      show_modal_add_product: false,
      products: false,
      model: {},
      newRow: {
        product_id: null,
        uom_id: null,
        qty: 1,
        cost: 0,
        cost_in_bath: 0,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: null,
        total_after_discount_in_bath: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        expiry_date: null,
        is_expire: false,
        require_imei: false,
        imei_list: [],
        product_grade: '',
        cpp_price_for_tax: null,
        cpp_rate: null,
        cpp_tax_amount: null,
        form_d_cpp_0: false,
        spp_price_for_tax: null,
        spp_rate: null,
        spp_tax_amount: null,
        vpp_price_for_tax: null,
        vpp_rate: null,
        vpp_tax_amount: null,
        total_tax_payment: null
      }
    }
  },
  created() {
    this.model = this.value
    this.$nextTick(() => this.calculate())
  },
  computed: {
    ...mapState('stock/stockIn', ['edit_data']),
    ...mapGetters('stock/stockIn', [
      'findProduct',
      'getProduct',
      'getUom',
      'isExpirable',
      'isDefaultUom',
      'getCostPrice'
    ]),
    isNotAllowUpdate() {
      return (
        !_.isEmpty(this.edit_data) &&
        (this.edit_data ? this.edit_data.is_confirm_stock : false)
      )
    },
    grandTotal() {
      return _.sumBy(this.model.product_detail, function(o) {
        return o.grand_total
      })
    },
    sumTotalQty() {
      return _.sumBy(this.model.product_detail, 'qty')
    },
    sumCost() {
      return _.round(_.sumBy(this.model.product_detail, 'cost'), 2)
    },
    sumTotalTax() {
      return _.round(
        _.sumBy(this.model.product_detail, item =>
          Number(item.total_tax_payment) || 0
        ),
        this.tax_precision
      )
    },
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    tax_precision() {
      return 8
    },
    isImportProduct() {
      return this.model.pi_product_type === 'import'
    }
  },
  methods: {
    addNewRow() {
      this.show_modal_add_product = true
      // this.model.product_detail.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.product_detail.splice(
        this.model.product_detail.indexOf(row),
        1
      )
    },
    onUomChange(row) {
      row.cost = this.getCostPrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      this.calculate()
    },
    onProductChange(row) {
      row.uom_id = this.isDefaultUom(row.product_id)
    },
    setTaxField(row, field, value) {
      if (row[field] !== value) {
        this.$set(row, field, value)
      }
    },
    formatTaxRate(rate) {
      return rate === null || rate === undefined || rate === ''
        ? ''
        : `${_.round(Number(rate) * 100, 4)}%`
    },
    clearImportTax(row) {
      const fields = [
        'cpp_price_for_tax', 'cpp_rate', 'cpp_tax_amount',
        'spp_price_for_tax', 'spp_rate', 'spp_tax_amount',
        'vpp_price_for_tax', 'vpp_rate', 'vpp_tax_amount',
        'total_tax_payment'
      ]
      fields.forEach(field => this.setTaxField(row, field, null))
      this.setTaxField(row, 'form_d_cpp_0', false)
    },
    calculateImportTax(row) {
      if (!this.isImportProduct) {
        this.clearImportTax(row)
        return
      }

      const product = this.findProduct(row.product_id)
      const rates = ['cpp_rate', 'spp_rate', 'vpp_rate']

      rates.forEach(field => {
        if (row[field] === null || row[field] === undefined || row[field] === '') {
          const productRate = product ? product[field] : null
          this.setTaxField(
            row,
            field,
            productRate === null || productRate === undefined || productRate === ''
              ? null
              : Number(productRate)
          )
        }
      })

      if (rates.some(field => row[field] === null)) {
        const taxAmountFields = [
          'cpp_price_for_tax', 'cpp_tax_amount', 'spp_price_for_tax',
          'spp_tax_amount', 'vpp_price_for_tax', 'vpp_tax_amount',
          'total_tax_payment'
        ]
        taxAmountFields.forEach(field => this.setTaxField(row, field, null))
        this.setTaxField(row, 'form_d_cpp_0', false)
        return
      }

      const roundTax = value => _.round(value, this.tax_precision)
      const cppBase = roundTax(
        (Number(row.qty) || 0) *
        (Number(row.cost) || 0) *
        (Number(this.model.fx_rate) || 0)
      )
      const cppAmount = roundTax(cppBase * Number(row.cpp_rate))
      const sppBase = roundTax(cppBase + cppAmount)
      const sppAmount = roundTax(sppBase * Number(row.spp_rate))
      const vppBase = roundTax(sppBase + sppAmount)
      const vppAmount = roundTax(vppBase * Number(row.vpp_rate))
      const totalTax = roundTax(
        sppAmount + vppAmount + (row.form_d_cpp_0 ? 0 : cppAmount)
      )

      this.setTaxField(row, 'cpp_price_for_tax', cppBase)
      this.setTaxField(row, 'cpp_tax_amount', cppAmount)
      this.setTaxField(row, 'spp_price_for_tax', sppBase)
      this.setTaxField(row, 'spp_tax_amount', sppAmount)
      this.setTaxField(row, 'vpp_price_for_tax', vppBase)
      this.setTaxField(row, 'vpp_tax_amount', vppAmount)
      this.setTaxField(row, 'total_tax_payment', totalTax)
      if (row.form_d_cpp_0 === undefined || row.form_d_cpp_0 === null) {
        this.setTaxField(row, 'form_d_cpp_0', false)
      }
    },
    calculate() {
      this.model.product_detail.forEach(el => {
        el.cost = _.round(el.cost, this.default_precision)
        el.cost_in_bath = _.round(el.cost_in_bath, this.default_precision)

        var amount = el.qty * el.cost
        var discount_amount =
          el.discount_type == '%'
            ? amount * (el.discount_rate / 100)
            : el.discount_rate

        var subtotal = amount - discount_amount
        var vatAmountRaw = subtotal * (el.vat_rate / 100)

        el.vat_amount = _.round(vatAmountRaw, this.default_precision)
        el.total_after_discount = _.round(
          subtotal + vatAmountRaw,
          this.default_precision
        )
        el.grand_total = _.round(
          subtotal + vatAmountRaw,
          this.default_precision
        )

        el.total_after_discount_in_bath = _.round(
          (subtotal + vatAmountRaw) * (this.model.fx_bath || 0),
          this.default_precision
        )

        el.is_expire = this.isExpirable(el.product_id)
        el.require_imei = this.findProduct(el.product_id)
          ? this.findProduct(el.product_id).require_imei
          : null
        this.calculateImportTax(el)
      })
    },
    pressEnterAddNewRow(index) {
      if (this.model.product_detail.length == index + 1) {
        this.addNewRow()
      }
      this.$nextTick(() => {
        this.$refs.barcode[index + 1].focus()
      })
    },
    onThbInput(row) {
      row.cost = _.round(
        row.cost_in_bath / this.model.fx_bath,
        this.default_precision
      )
      this.calculate()
    },
    onUsdInput(row) {
      row.cost_in_bath = _.round(
        row.cost * this.model.fx_bath,
        this.default_precision
      )
      this.calculate()
    },
    onCostEnter(index) {
      this.$refs.qty[index].focus()
    },
    onQtyEnter(index) {
      this.$refs.discountRate[index].focus()
    },
    onDiscountRateEnter(index) {
      this.$refs.discountType[index].focus()
    },
    discountTypeEnter(index) {
      this.$refs.vatRate[index].focus()
    },
    onFileChange(e, product) {
      var file = e.target.files[0]
      var fileName = file.name
      if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        // product.label = fileName
        var reader = new FileReader()
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = this.readExcelData(data)

          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          product.imei_list = this.parseWorksheetData(worksheet)
          product.qty = product.imei_list.length
        }
        reader.readAsArrayBuffer(file)
        return
      }
      this.$toasted.error('Not a valid Excel file')
    },
    readExcelData(data) {
      var arr = new Array()
      for (var i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i])
      }
      var bstr = arr.join('')
      return XLSX.read(bstr, { type: 'binary' })
    },
    parseWorksheetData(worksheet) {
      var jsonData = []
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        const row = {}
        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: 0 })
          const cell = worksheet[cellAddress]

          if (cell) {
            row = cell.v
          }
        }
        if (Object.keys(row).length) {
          jsonData.push({ 0: row })
        }
      }
      return jsonData
    }
  },
  watch: {
    'model.pi_product_type'() {
      this.calculate()
    },
    'model.product_detail': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.fx_bath': function(newRate, oldRate) {
      if (newRate && oldRate && newRate !== oldRate) {
        this.model.product_detail.forEach(detail => {
          if (detail.cost) {
            // recalculate THB when fx_bath changed
            detail.cost_in_bath = _.round(
              detail.cost * newRate,
              this.default_precision
            )
          }
        })
        this.calculate()
      }
    },
    'model.fx_rate': function() {
      this.calculate()
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

table thead tr th {
  padding: 4px 5px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
  background-color: rgb(22, 102, 145);
  color: white;
}

.scroll {
  height: 200px;
  min-height: 220px;
  overflow: scroll;
}

table tbody tr td {
  padding: 4px 5px;
}

table {
  position: relative;
  border-collapse: collapse;
}

.footer-total {
  padding: 4px 5px;
  font-weight: 800;
  white-space: nowrap;
}

.action-column {
  position: sticky;
  left: 0;
  z-index: 4;
  min-width: 34px;
  width: 34px;
}

tbody .action-column {
  background: white;
}

.tax-column {
  border: 1px solid #d1d5db;
  min-width: 125px;
  text-align: center;
}

.tax-cell {
  min-width: 140px;
}

.tax-rate-cell {
  min-width: 95px;
}

.form-d-cell {
  min-width: 115px;
  vertical-align: middle;
}

.form-d-cell input {
  width: 16px;
  height: 16px;
}

.total-tax-cell input {
  font-weight: 700;
}
</style>
